module.exports = require('./sha512')
module.exports.hmac = require('./hmac')